import { MatchTypes } from '../../../../../shared/types';

export const matchTypes: { id: MatchTypes; name: string }[] = [
  {
    name: 'All',
    id: 'ALL',
  },
  {
    name: 'Any',
    id: 'ANY',
  },
];

export const types = [
  {
    name: 'Contacts',
    id: 'contacts',
  },
  {
    name: 'Segments',
    id: 'segments',
  },
  {
    name: 'Lists',
    id: 'lists',
  },
];
